module.exports = __webpack_public_path__ + "static/media/elektroschetchiki.9afd102b.png";